import React from "react"
import { Grid } from "@mui/material"

import { AppCrudTable } from "@components"
import { userSettingOfficesGroupData } from "../@signals"
import { actionsColumn, nameColumn, officesColumn } from "./columns"
import UserSettingOfficesGroupTabButton from "./Button"
import UserSettingOfficesGroupDrawer from "./Drawer"
import { isTourDemoActive } from "@signals/app"


export default function UserSettingOfficesGroupTab() {

	return <Grid container spacing={1}>
		<Grid item xs={12} sx={{  display: 'flex', justifyContent: 'flex-end'  }}>
			<UserSettingOfficesGroupTabButton />
		</Grid>

		{(!isTourDemoActive.value || !!userSettingOfficesGroupData.value?.length) && <Grid item xs={12}>
			<AppCrudTable
				title="Your Offices Group"
				data={userSettingOfficesGroupData.value}
				columns={[
					nameColumn(),
					officesColumn(),
					actionsColumn()
				]}
			/>
		</Grid>}

		<UserSettingOfficesGroupDrawer />
	</Grid>
}